import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { tr } from "@/lib/i18n";

export default function ResetPassword() {
  const { lang } = useAuth();
  const t = (k) => tr(k, lang);
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error(t("auth.reset_bad_token")); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t("auth.reset_done"));
      nav("/login", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("auth.reset_fail"));
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto pt-6" data-testid="reset-password-page">
      <div className="mono text-[11px] tracking-[0.4em] text-amber-500 uppercase">
        {t("auth.entry")}
      </div>
      <h1 className="serif text-4xl text-stone-100 mt-2">{t("auth.reset_title")}</h1>
      <p className="text-stone-400 mt-2 text-sm">{t("auth.reset_hint")}</p>

      <form onSubmit={submit} className="space-y-3 mt-8">
        <div>
          <label className="label-cap">{t("auth.new_password")}</label>
          <input
            data-testid="reset-password-input"
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="script-input mt-1"
            placeholder={t("auth.password_hint")}
          />
        </div>
        <button
          data-testid="reset-password-submit"
          type="submit"
          disabled={busy}
          className="pill-btn w-full mt-2"
        >
          {busy ? t("auth.wait") : t("auth.reset_submit")}
        </button>
      </form>

      <div className="mt-8 text-xs text-stone-500">
        <Link to="/login" className="hover:text-stone-300">{t("auth.back_to_login")}</Link>
      </div>
    </div>
  );
}
